<template>
    <sys-teacher-hub-modal
        :show.sync="localShow"
        title="Perfil do Docente"
        max-width="980"
    >
        <v-card-text class="pa-0">
            <div v-if="loading" class="pa-8 text-center">
                <v-progress-circular indeterminate color="primary" size="48" />
                <p class="mt-4 mb-0 text-body-1 grey--text">Carregando perfil...</p>
            </div>

            <v-alert
                v-else-if="errorMessage"
                type="error"
                outlined
                dense
                class="ma-4"
            >
                {{ errorMessage }}
            </v-alert>

            <div v-else-if="profileTeacher" class="pa-4">
                <v-row class="mb-2">
                    <v-col cols="12" md="3" class="d-flex justify-center align-start">
                        <emc-avatar-teacher
                            :model="profileTeacher"
                            :token="token || ''"
                            :show-menu="true"
                            width="96"
                            height="96"
                        />
                    </v-col>
                    <v-col cols="12" md="9">
                        <div class="text-h6 font-weight-bold">{{ profileTeacher.name }}</div>
                        <div class="text-body-1 text--secondary">{{ teacherTitulation }}</div>
                        <v-divider class="mt-4" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="text-overline font-weight-bold text--secondary">INFORMAÇÕES INSTITUCIONAIS</div>
                        <div class="d-flex align-center mb-2">
                            <v-icon small class="mr-2">mdi-email-outline</v-icon>
                            <span class="font-weight-medium mr-2">E-mail:</span>
                            <span>{{ institutionalEmail }}</span>
                        </div>
                        <div class="d-flex align-center">
                            <v-icon small class="mr-2">mdi-school-outline</v-icon>
                            <span class="font-weight-medium mr-2">Titulação:</span>
                            <span>{{ teacherTitulation }}</span>
                        </div>
                        <v-divider class="my-4" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="text-overline font-weight-bold text--secondary">INFORMAÇÕES PESSOAIS</div>
                        <div class="font-weight-medium mb-1">Endereço</div>
                        <v-text-field
                            dense
                            outlined
                            prepend-inner-icon="mdi-map-marker-outline"
                            :value="formattedAddress"
                            readonly
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-expansion-panels class="mt-4" multiple>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            Atualização Cadastral (Telefones, Links e E-mails)
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <sys-teacher-update-data
                                :model="profileTeacher"
                                :token="token"
                                @onComplete="handleComplete"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            Endereço
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <sys-address-register
                                :model="profileTeacher"
                                type="teacher"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </v-card-text>
    </sys-teacher-hub-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysTeacherProfileHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            default: () => ({})
        },
        token: {
            type: String,
            default: null
        }
    },
    data: () => ({
        loading: false,
        errorMessage: '',
        profileTeacher: null
    }),
    computed: {
        localShow: {
            get() { return this.show },
            set(value) { this.$emit('update:show', value) }
        },
        institutionalEmail() {
            if (!this.profileTeacher || !this.profileTeacher.emails) return '-'
            const email = this.profileTeacher.emails.find((item) => !item.allow_editing) || this.profileTeacher.emails[0]
            return email?.email || '-'
        },
        teacherTitulation() {
            return this.profileTeacher?.titling?.name || 'Não informado'
        },
        formattedAddress() {
            const address = this.profileTeacher?.addresses?.[0]
            if (!address) return 'Endereço não informado'

            const line = [address.address, address.address_number].filter(Boolean).join(', ')
            const city = address.city?.name
            const state = address.state?.initials
            const location = [city, state].filter(Boolean).join(' - ')
            return [line, location].filter(Boolean).join(' - ') || 'Endereço não informado'
        }
    },
    watch: {
        show(value) {
            if (value) this.loadProfile()
        }
    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeacher', 'ActionFindTeacherByToken']),
        async loadProfile() {
            this.loading = true
            this.errorMessage = ''

            try {
                const relations = 'emails,titling,addresses.city,addresses.state,addresses.country'
                const response = this.token
                    ? await this.ActionFindTeacherByToken({
                        token: this.token,
                        with: relations
                    })
                    : await this.ActionFindTeacher({
                        id: this.teacher?.id,
                        with: relations
                    })

                this.profileTeacher = response?.data || null
            } catch (error) {
                this.errorMessage = 'Não foi possível carregar os dados do perfil.'
            } finally {
                this.loading = false
            }
        },
        handleComplete(event) {
            if (!event || !event.text) return
            this.$emit('onComplete', event)
            this.loadProfile()
        }
    }
}
</script>
